/**
 * features/compliance/complianceWrite.ts
 */
import { collection, deleteDoc, deleteField, doc } from 'firebase/firestore';
import { db, addDoc, updateDoc } from '@/lib/firebase';
import { COLLECTIONS, type ComplianceKind } from '@/types';

export interface CompliancePayload {
  kind: ComplianceKind;
  title: string;
  reference?: string;
  authority?: string;
  issueDate?: string;
  expiryDate?: string;
  attachmentUrl?: string;
  attachmentName?: string;
  notes?: string;
}

function base(p: CompliancePayload) {
  const data: Record<string, unknown> = {
    kind: p.kind,
    title: p.title.trim(),
    updatedAt: new Date().toISOString(),
  };
  const opt = (k: string, v?: string) => {
    const t = v?.trim();
    if (t) data[k] = t;
  };
  opt('reference', p.reference);
  opt('authority', p.authority);
  opt('issueDate', p.issueDate);
  opt('expiryDate', p.expiryDate);
  opt('attachmentUrl', p.attachmentUrl);
  opt('attachmentName', p.attachmentName);
  opt('notes', p.notes);
  return data;
}

export async function addComplianceItem(p: CompliancePayload, actor: string): Promise<string> {
  const ref = await addDoc(collection(db, COLLECTIONS.complianceItems), {
    ...base(p),
    createdAt: new Date().toISOString(),
    createdBy: actor,
  });
  return ref.id;
}

export async function updateComplianceItem(id: string, p: CompliancePayload): Promise<void> {
  const data = base(p);
  // Explicitly clear fields that were emptied.
  for (const k of ['reference', 'authority', 'issueDate', 'expiryDate', 'attachmentUrl', 'attachmentName', 'notes'] as const) {
    if (data[k] === undefined) data[k] = deleteField();
  }
  await updateDoc(doc(db, COLLECTIONS.complianceItems, id), data);
}

export async function deleteComplianceItem(id: string): Promise<void> {
  await deleteDoc(doc(db, COLLECTIONS.complianceItems, id));
}
